export default __webpack_public_path__ + "static/media/banner-sobre-nos-mobile.eefbf3e7.png";